
import React, { useState } from 'react'
import "./style.scss"

import Menu from '../../components/Menu'
import Footer from '../../components/Footer'

import Diamante from '../../assets/imagens/medalha-diamante.png'
import Ouro from '../../assets/imagens/medalha-ouro.png'
import Prata from '../../assets/imagens/medalha-prata.png'
import Bronze from '../../assets/imagens/medalha-bronze.png'
import Avaliacao from '../../assets/imagens/medalha-avaliacao.679d1f19.png'
import Inativa from '../../assets/imagens/Inativa-110x150px-EbitNielsen20-d01.png'

import imgBanner2 from '../../assets/imagens/img-consumidor3.40d1bdeb.JPG'

import MedalGold from '../../assets/imagens/pag-LandingPage-Box-OtimaMedalhas-h.84268a74.png'
import MedalDiamond from '../../assets/imagens/pag-LandingPage-Box-ExcelenteMedalha-h.c1fb684e.png'
import MedalSilver from '../../assets/imagens/pag-LandingPage-Box-MuitoBoaMedalha-h.2236114a.png'
import MedalBronze from '../../assets/imagens/pag-LandingPage-Box-BoaMedalha-h.705c6fb6.png'
import MedalAvailable from '../../assets/imagens/pag-LandingPage-Box-AvaliacaoMedalha-h.53c2e049.png'
import MedalInactive from '../../assets/imagens/LandingPage-Box-InativaMedalha-h-06.png'

// import MedalGold from '../../assets/imagens/medalhas/LandingPage-Box-Medalhas-h-2021-03.png'
// import MedalDiamond from '../../assets/imagens/medalhas/LandingPage-Box-Medalhas-h-2021-04.png'
// import MedalSilver from '../../assets/imagens/medalhas/LandingPage-Box-Medalhas-h-2021-02.png'
// import MedalBronze from '../../assets/imagens/medalhas/LandingPage-Box-Medalhas-h-2021-01.png'
// import MedalAvailable from '../../assets/imagens/medalhas/LandingPage-Box-Medalhas-h-2021-05.png'
// import MedalInactive from '../../assets/imagens/medalhas/LandingPage-Box-Medalhas-h-2021-06.png'




const MedalEbit = () => {

  const [visibleMedalGold, setVisibleMedalGold] = useState(false);
  const [visibleMedalDiamond, setVisibleMedalDiamond] = useState(false);
  const [visibleMedalSilver, setVisibleMedalSilver] = useState(false);
  const [visibleMedalBronze, setVisibleMedalBronze] = useState(false);
  const [visibleMedalAvailable, setVisibleMedalAvailable] = useState(false);
  const [visibleMedalInactive, setVisibleMedalInactive] = useState(false);

  const toggleMedalGold = () => {
    setVisibleMedalGold(!visibleMedalGold) 
    setVisibleMedalSilver(false)
    setVisibleMedalDiamond(false)
    setVisibleMedalBronze(false)
    setVisibleMedalAvailable(false)
    setVisibleMedalInactive(false)
  }

  const toggleMedalDiamond = () => {
    setVisibleMedalDiamond(!visibleMedalDiamond) 
    setVisibleMedalSilver(false)
    setVisibleMedalGold(false)
    setVisibleMedalBronze(false)
    setVisibleMedalAvailable(false)
    setVisibleMedalInactive(false)
  }

  const toggleMedalSilver = () => {
    setVisibleMedalSilver(!visibleMedalSilver) 
    setVisibleMedalGold(false)
    setVisibleMedalDiamond(false)
    setVisibleMedalBronze(false)
    setVisibleMedalAvailable(false)
    setVisibleMedalInactive(false)
  }

  const toggleMedalBronze = () => {
    setVisibleMedalBronze(!visibleMedalBronze) 
    setVisibleMedalSilver(false)
    setVisibleMedalDiamond(false)
    setVisibleMedalGold(false)
    setVisibleMedalAvailable(false)
    setVisibleMedalInactive(false)
  }

  const toggleMedalAvailable = () => {
    setVisibleMedalAvailable(!visibleMedalAvailable) 
    setVisibleMedalSilver(false)
    setVisibleMedalDiamond(false)
    setVisibleMedalBronze(false)
    setVisibleMedalGold(false)
    setVisibleMedalInactive(false)
  }

  const toggleMedalInactive = () => {
    setVisibleMedalInactive(!visibleMedalInactive) 
    setVisibleMedalSilver(false)
    setVisibleMedalDiamond(false)
    setVisibleMedalBronze(false)
    setVisibleMedalAvailable(false)
    setVisibleMedalGold(false)
  }



  return (
    <>

      <Menu/>

      <div className="aboutUs-medal-pag container">
        <h3>Medalhas EBIT | NIELSEN</h3>
        <h5>Clique nas medalhas abaixo para ver mais informações</h5>
        <div className="aboutUs-medal-pag__newMedals-2 container">

        <div>
            <img src={Bronze} title="Medalha Bronze" alt="Medalha Bronze" onClick={toggleMedalBronze}/>
            {visibleMedalBronze &&
              <div className="img-toggle-medal">
                <img src={MedalBronze} alt="" />
              </div>
            }
          </div>
          <div>
            <img src={Prata} title="Medalha Prata" alt="Medalha Prata" onClick={toggleMedalSilver}/>
            {visibleMedalSilver &&
              <div className="img-toggle-medal">
                <img src={MedalSilver} alt="" />
              </div>
            }
          </div>
          <div>
            <img src={Ouro} title="Medalha Ouro" alt="Medalha Ouro" onClick={toggleMedalGold} />
            {visibleMedalGold &&
              <div className="img-toggle-medal">
                <img src={MedalGold} alt="" />
              </div>
            }
          </div>
          <div>
            <img src={Diamante} title="Medalha Diamante" alt="Medalha Diamante" onClick={toggleMedalDiamond}/>
            {visibleMedalDiamond &&
              <div className="img-toggle-medal">
                <img src={MedalDiamond} alt="" />
              </div>
            }
          </div>     
          <div>
            <img src={Avaliacao} title="Medalha Avaliação" alt="Medalha Avaliação" onClick={toggleMedalAvailable} />
            {visibleMedalAvailable &&
              <div className="img-toggle-medal avaliacao">
                <img src={MedalAvailable} alt="" />
              </div>
            }
          </div>
          <div>
            <img src={Inativa} title="Medalha Inativa" alt="Medalha Inativa" onClick={toggleMedalInactive}/>
            {visibleMedalInactive &&
              <div className="img-toggle-medal inactiveMedal">
                <img src={MedalInactive} alt="" />
              </div>
            }
          </div>
        </div>
      </div>

      <div className="infos-medals-true container">
        <h4>Como atestar se uma medalha Ebit | Nielsen é verdadeira?</h4>
        <p className="lead">Sempre que encontrar nossa medalha em site de e-commerce, clique nela e espere carregar a página de loja virtual no site Ebit | Nielsen. É desta maneira que atestamos se a medalha é verdadeira.</p>
      </div>

      <div className="img-banner-secondary-medal container">
        <img src={imgBanner2} alt="Banner Medalhas" />
      </div>

      <section>
        <div className="new-medals-methodology">
          
        </div>
      </section>

      <Footer/>
    </>

  )
}

export default MedalEbit